import React from 'react';
import logo from './logo.svg';

const Footer = () => (
  <footer className="bg-white border-t border-gray-200 py-8 sm:py-10 md:py-12 px-4 sm:px-6" id='footer'>
    <div className="max-w-6xl mx-auto text-center">
      <div className="flex items-center justify-center gap-2 mb-4">
        <img src={logo} alt="Fylo" className="w-20 h-auto" />
      </div>
      <p className="text-sm text-gray-600 mb-6 sm:mb-8 px-4">Made for those who design with intention.</p>
      
      <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 text-sm uppercase tracking-wider">
        <a href="#" className="text-gray-600 hover:text-black transition-colors">Docs</a>
        <a href="#" className="text-gray-600 hover:text-black transition-colors">Support</a>
        <a href="#" className="text-gray-600 hover:text-black transition-colors">Privacy</a>
        <a href="#" className="text-gray-600 hover:text-black transition-colors">Twitter/X</a>
        <a href="#" className="text-gray-600 hover:text-black transition-colors">GitHub</a>
      </div>
    </div>
  </footer>
);

export default Footer;